import { createTheme, darken } from '@mui/material';
import {
	ACCENT_COLOR,
	TERTIARY_COLOR,
	TERTIARY_LIGHT_COLOR,
} from 'utils/constants';
import { ICustomTheme } from '../../models/ICustomTheme';

export const theme: ICustomTheme = createTheme({
	palette: {
		primary: {
			main: TERTIARY_LIGHT_COLOR,
		},
	},
	typography: {
		fontFamily: [
			'DIN',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
		].join(','),
	},
	components: {
		MuiFormControl: {
			styleOverrides: {
				root: {
					width: '100%',
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				input: {
					padding: '12px 16px',
				},
				root: {
					'&.Mui-focused': {
						'& .MuiOutlinedInput-notchedOutline': {
							borderWidth: 1,
						},
					},
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					top: '50%',
					'&.MuiInputLabel-shrink': {
						top: 0,
					},
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontSize: 14,
					'&:hover': {
						backgroundColor: 'rgba(7, 13, 88, 0.05)',
					},
					'&.Mui-selected': {
						backgroundColor: 'rgba(7, 13, 88, 0.05)',
						'&:hover': {
							backgroundColor: 'rgba(7, 13, 88, 0.05)',
						},
					},
				},
			},
		},
		MuiSwitch: {
			styleOverrides: {
				thumb: {
					color: TERTIARY_COLOR,
					'.MuiSwitch-switchBase.Mui-disabled &': {
						color: 'rgb(245, 245, 245)',
					},
				},
				track: {
					backgroundColor: TERTIARY_COLOR,
					opacity: 0.3,
					'.MuiSwitch-switchBase.Mui-checked + &': {
						opacity: 0.3,
					},
					'.MuiSwitch-switchBase.Mui-disabled + &': {
						backgroundColor: 'rgb(0, 0, 0)',
					},
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				subtitle2: {
					fontSize: 20,
					fontWeight: 'normal',
					lineHeight: 1.5,
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: '#FFF',
					fontSize: 14,
					boxShadow: '0 4px 14px rgba(7, 13, 88, 0.12)',
					padding: 20,
					color: 'rgba(0, 7, 51, 0.8)',
					fontWeight: 'normal',
				},
			},
		},
		MuiFab: {
			styleOverrides: {
				root: {
					backgroundColor: TERTIARY_COLOR,
					width: 20,
					height: 20,
					minHeight: 20,
					padding: 5,
					boxShadow: 'none',
					'& svg': {
						fill: '#FFF',
					},
					'&:hover': {
						backgroundColor: darken(TERTIARY_COLOR, 0.05),
					},
					zIndex: 30,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					fontWeight: 400,
				},
			},
		},
		MuiRadio: {
			styleOverrides: {
				root: {
					padding: 0,
					marginRight: 9,
					color: '#dadada',
				},
			},
		},
	},
});
